/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationForFinopsUnderUtilizedAwsComputeOptimizerResource extends models.RecommendationBaseForFinopsResource {
    constructor() {
        super();
        this.setDiscriminator("RecommendationForFinopsUnderUtilizedAwsComputeOptimizerResource");
    }

    getFixupPrototypeFunction() { return RecommendationForFinopsUnderUtilizedAwsComputeOptimizerResource.fixupPrototype; }

    static newInstance(model: Partial<RecommendationForFinopsUnderUtilizedAwsComputeOptimizerResource>): RecommendationForFinopsUnderUtilizedAwsComputeOptimizerResource {
        let obj = Object.assign(new RecommendationForFinopsUnderUtilizedAwsComputeOptimizerResource(), model);
        RecommendationForFinopsUnderUtilizedAwsComputeOptimizerResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationForFinopsUnderUtilizedAwsComputeOptimizerResource>): RecommendationForFinopsUnderUtilizedAwsComputeOptimizerResource {
        if (!model) return null;
        return RecommendationForFinopsUnderUtilizedAwsComputeOptimizerResource.newInstance(<RecommendationForFinopsUnderUtilizedAwsComputeOptimizerResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationForFinopsUnderUtilizedAwsComputeOptimizerResource) {
        if (!obj) return;

        models.RecommendationForFinopsUnderUtilizedAwsComputeOptimizerResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationForFinopsUnderUtilizedAwsComputeOptimizerResource): boolean {
        if (models.RecommendationBaseForFinopsResource.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationForFinopsUnderUtilizedAwsComputeOptimizerResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
